import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { supabase } from "@/integrations/supabase/client";
import { AuthLayout } from "@/components/auth/AuthLayout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AccessiSocial } from "@/components/auth/AccessiSocial";
import { destinazioneDopoAccesso } from "@/lib/dopoAccesso";
import { registrazioneNellApp } from "@/lib/iscrizione";

export default function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    try {
      const { error } = await supabase.auth.signInWithPassword({ email, password });
      if (error) {
        toast.error("Credenziali non valide");
        return;
      }
      navigate(destinazioneDopoAccesso(location.state), { replace: true });
    } finally {
      setLoading(false);
    }
  };


  return (
    <AuthLayout title="Accedi">
      <form onSubmit={onSubmit} className="space-y-4">
        <div className="space-y-1.5">
          <Label htmlFor="email">Email</Label>
          <Input
            id="email"
            type="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="space-y-1.5">
          <div className="flex items-center justify-between">
            <Label htmlFor="password">Password</Label>
            <Link
              to="/forgot-password"
              className="text-xs text-primary hover:underline"
            >
              Password dimenticata?
            </Link>
          </div>
          <Input
            id="password"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <Button type="submit" className="w-full bg-accent text-accent-foreground hover:bg-accent/90" disabled={loading}>
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Accedi"}
        </Button>

        {/* Sull'iPhone solo l'accesso (Apple 3.1.1, quarto rifiuto, 05/10/2026):
            niente «Registrati» e niente Google/Apple, che al primo accesso
            CREANO l'account. Resta cio' che si usa senza account. */}
        {registrazioneNellApp() ? (
          <>
            <AccessiSocial />

            <p className="pt-2 text-center text-sm text-muted-foreground">
              Non hai un account?{" "}
              <Link to="/signup" className="text-primary hover:underline">
                Registrati
              </Link>
            </p>
          </>
        ) : (
          <p className="pt-2 text-center text-sm text-muted-foreground">
            Gli{" "}
            <Link to="/strumenti" className="text-primary hover:underline">
              strumenti di calcolo
            </Link>{" "}
            si usano anche senza account.
          </p>
        )}
      </form>
    </AuthLayout>
  );
}